import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../../store/useAuthStore'
import {
  ApiResponse,
  RegisterUserRequest,
  SignInRequest,
  User,
} from '../../types/user'
import axiosInstance from '../axios'

// 사용자 등록 API
const registerUser = async (
  userData: RegisterUserRequest
): Promise<ApiResponse> => {
  const response = await axiosInstance.post<ApiResponse>(
    '/users/register',
    userData
  )
  return response.data
}

// 로그인 API
const loginUser = async (loginData: SignInRequest): Promise<ApiResponse> => {
  const response = await axiosInstance.post<ApiResponse>(
    '/users/login',
    loginData
  )
  return response.data
}

// 회원가입 훅
export const useRegister = () => {
  return useMutation({
    mutationFn: registerUser,
  })
}

// 로그인 훅 - 성공 시 상태 관리 및 리다이렉트 처리
export const useLogin = () => {
  const navigate = useNavigate()
  const signIn = useAuthStore((state) => state.signIn)

  return useMutation({
    mutationFn: loginUser,
    onSuccess: (data, variables) => {
      if (data.success === 'Y') {
        const user: User = {
          USER_ID: data.data.USER_ID,
          STATUS: data.data.STATUS,
          NAME: data.data.NAME,
          TEST: data.data.TEST,
          AVATAR: data.data.AVATAR,
          ID: data.data.ID,
          NICKNAME: data.data.NICKNAME,
          STEP: data.data.STEP,
          LEVEL_ID: data.data.LEVEL_ID,
          SUB: data.data.SUB,
          CENTER_ID: data.data.CENTER_ID,
          PARENT_ID: data.data.PARENT_ID,
        }

        signIn(user, variables.KEEP_LOGGED_IN || false)
        navigate('/')
      }
    },
  })
}

// 로그아웃 함수
// navigate() 대신 전체 페이지 이동을 사용 — 배포 후에도 이미 열려있던 탭이
// 예전 JS 번들을 계속 쓰는 것을 방지 (로그아웃마다 최신 빌드를 새로 받아오게 함)
export const useLogout = () => {
  const queryClient = useQueryClient()
  const signOut = useAuthStore((state) => state.signOut)

  return () => {
    signOut()

    queryClient.clear()

    window.location.href = '/signin'
  }
}
